(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["product-binding"] && !Shopify.designMode) return;
  try {
    (function () {
    if (customElements.get('product-binding-card')) return;

    const groups = new WeakMap();

    function paintContainer(container, price, compare) {
      const regular = container.querySelector('.price__regular');
      const sale = container.querySelector('.price__sale');
      const hasCompare = compare !== '';
      regular?.classList.toggle('price__hidden', hasCompare);
      sale?.classList.toggle('price__hidden', !hasCompare);
      const current = hasCompare ? container.querySelector('.price-item--sale') : regular?.querySelector('.price');
      if (current) current.textContent = price;
      const compareEl = container.querySelector('.compare-at-price');
      if (hasCompare && compareEl) compareEl.textContent = compare;
      container.querySelector('.unit-price')?.setAttribute('hidden', '');
    }

    function paintBindingPrice(group, card) {
      const price = card.dataset.price || '';
      const compare = card.dataset.compare || '';
      const pageId = group.form?.dataset.productId;
      group.section.querySelectorAll('product-price').forEach((node) => {
        if (!(node instanceof HTMLElement)) return;
        if (pageId && node.dataset.productId && node.dataset.productId !== pageId) return;
        const container = node.querySelector('[ref="priceContainer"]');
        if (container) paintContainer(container, price, compare);
      });
      group.section.querySelectorAll('.sticky-add-to-cart__price [ref="priceContainer"]').forEach((container) => {
        paintContainer(container, price, compare);
      });
    }

    function purchaseButtons(group) {
      return group.section.querySelectorAll('product-form-component [ref="addToCartButton"], .sticky-add-to-cart__button');
    }

    function syncPurchase(group, available) {
      const accel = group.form?.querySelector('[ref="acceleratedCheckoutButtonContainer"]');
      if (accel instanceof HTMLElement && group.accelHidden == null) group.accelHidden = accel.hidden;
      if (accel instanceof HTMLElement) accel.hidden = !available;
      const text = available ? group.addLabel : group.soldOutLabel;
      purchaseButtons(group).forEach((button) => {
        const label = button.querySelector('.add-to-cart-text__content > span');
        if (!group.snapshots.has(button)) {
          group.snapshots.set(button, { text: label?.textContent || '', disabled: button.disabled });
        }
        if (label) label.textContent = text;
        button.disabled = !available;
      });
    }

    function restorePurchase(group) {
      purchaseButtons(group).forEach((button) => {
        const saved = group.snapshots.get(button);
        if (!saved) return;
        const label = button.querySelector('.add-to-cart-text__content > span');
        if (label) label.textContent = saved.text;
        button.disabled = saved.disabled;
        group.snapshots.delete(button);
      });
      const accel = group.form?.querySelector('[ref="acceleratedCheckoutButtonContainer"]');
      if (accel instanceof HTMLElement && group.accelHidden != null) {
        accel.hidden = group.accelHidden;
        group.accelHidden = null;
      }
    }

    function syncPayCover(group) {
      const host = group.form?.querySelector('.shopify-payment-button');
      const existing = group.form?.querySelector('.product-binding-pay');
      const card = group.selected;
      const redirect = Boolean(
        card &&
          group.form?.dataset.productId &&
          card.dataset.productId !== group.form.dataset.productId &&
          card.dataset.variantId
      );
      if (redirect && group.form && !group.payWatch) {
        group.payWatch = new MutationObserver(() => {
          const nextHost = group.form?.querySelector('.shopify-payment-button');
          const cover = group.form?.querySelector('.product-binding-pay');
          if (nextHost && !cover) syncPayCover(group);
        });
        group.payWatch.observe(group.form, { childList: true, subtree: true });
      }
      if (!redirect || !(host instanceof HTMLElement)) {
        existing?.remove();
        return;
      }
      if (getComputedStyle(host).position === 'static') host.style.position = 'relative';
      if (existing) return;
      const cover = document.createElement('button');
      cover.type = 'button';
      cover.className = 'product-binding-pay';
      cover.tabIndex = -1;
      cover.setAttribute('aria-hidden', 'true');
      host.append(cover);
    }

    function showError(group, message) {
      const error = group.form?.querySelector('.product-form-text__error');
      if (!(error instanceof HTMLElement)) return;
      error.classList.remove('hidden');
      const text = message || group.soldOutLabel;
      const node = error.childNodes[2];
      if (node) node.textContent = text;
      else error.append(document.createTextNode(text));
    }

    function checkoutBinding(group) {
      const card = group.selected;
      if (!card || group.busy || card.dataset.available !== 'true') return;
      group.busy = true;
      const quantityInput = group.form?.querySelector('input[name="quantity"]');
      const quantityValue = Number(quantityInput instanceof HTMLInputElement ? quantityInput.value : 1);
      const quantity = Number.isFinite(quantityValue) && quantityValue > 0 ? quantityValue : 1;

      fetch(window.Theme?.routes?.cart_add_url || '/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ id: Number(card.dataset.variantId), quantity }),
      })
        .then((response) => response.json().then((data) => ({ ok: response.ok, data })))
        .then(({ ok, data }) => {
          if (!ok || data.status) {
            group.busy = false;
            showError(group, data.description || data.message || '');
            return;
          }
          const cartUrl = window.Theme?.routes?.cart_url || '/cart';
          window.location.assign(cartUrl.endsWith('/cart') ? cartUrl.replace(/\/cart$/, '/checkout') : '/checkout');
        })
        .catch(() => {
          group.busy = false;
          showError(group, '');
        });
    }

    class ProductBindingGroup {
      constructor(list) {
        this.list = list;
        this.section = list.closest('.shopify-section') || document;
        this.cards = [];
        this.selected = null;
        this.snapshots = new WeakMap();
        this.accelHidden = null;
        this.originVariant = null;
        this.payWatch = null;
        this.bound = false;
        this.busy = false;
        this.addLabel = list.dataset.labelAdd || 'Add to cart';
        this.soldOutLabel = list.dataset.labelSoldOut || 'Sold out';
      }

      get form() {
        return this.section.querySelector('product-form-component');
      }

      add(card) {
        if (this.cards.includes(card)) return;
        this.cards.push(card);
        card.bindingGroup = this;
        card.querySelector('.product-binding__card')?.addEventListener('click', () => this.select(card));
      }

      remove(card) {
        this.cards = this.cards.filter((item) => item !== card);
        if (this.selected !== card) return;
        this.clear();
      }

      clear() {
        this.selected = null;
        for (const item of this.cards) {
          item.querySelector('.product-binding__card')?.setAttribute('aria-checked', 'false');
        }
        const form = this.form;
        if (form && this.originVariant != null) {
          form.querySelectorAll('form [name="id"]').forEach((input) => {
            if (input instanceof HTMLInputElement) input.value = this.originVariant || '';
          });
          this.originVariant = null;
        }
        const plan = form?.querySelector('form [name="selling_plan"]');
        if (plan instanceof HTMLInputElement) plan.disabled = false;
        restorePurchase(this);
        syncPayCover(this);
      }

      select(card) {
        this.selected = card;
        for (const item of this.cards) {
          const pressed = item === card ? 'true' : 'false';
          item.querySelector('.product-binding__card')?.setAttribute('aria-checked', pressed);
        }
        this.bind();
        this.apply();
      }

      bind() {
        if (this.bound) return;
        this.bound = true;
        this.section.addEventListener('variant:update', () => {
          this.apply({ refresh: true });
          queueMicrotask(() => this.apply());
        });
        this.section.addEventListener('keydown', (event) => this.onKey(event));
        this.section.addEventListener('click', (event) => this.onPay(event), true);
      }

      onKey(event) {
        if (event.key !== 'ArrowDown' && event.key !== 'ArrowUp') return;
        if (!(event.target instanceof Node) || !this.list.contains(event.target)) return;
        const radios = [...this.list.querySelectorAll('[role="radio"]')];
        const index = radios.indexOf(document.activeElement);
        if (index < 0) return;
        event.preventDefault();
        const step = event.key === 'ArrowDown' ? 1 : -1;
        const next = radios[(index + step + radios.length) % radios.length];
        if (next instanceof HTMLElement) next.click();
      }

      apply(options) {
        const card = this.selected;
        const form = this.form;
        if (!card || !form) return;
        if (options?.refresh) {
          this.snapshots = new WeakMap();
          this.accelHidden = null;
        }

        const same = card.dataset.productId === form.dataset.productId;
        const plan = form.querySelector('form [name="selling_plan"]');
        if (plan instanceof HTMLInputElement) plan.disabled = !same;
        syncPayCover(this);

        if (!same && card.dataset.variantId) {
          const current = form.querySelector('form [name="id"]');
          if (current instanceof HTMLInputElement && current.value && current.value !== card.dataset.variantId) {
            this.originVariant = current.value;
          }
          form.querySelectorAll('form [name="id"]').forEach((input) => {
            if (input instanceof HTMLInputElement) input.value = card.dataset.variantId || '';
          });
          paintBindingPrice(this, card);
          syncPurchase(this, card.dataset.available === 'true');
          return;
        }

        if (this.originVariant != null) {
          form.querySelectorAll('form [name="id"]').forEach((input) => {
            if (input instanceof HTMLInputElement) input.value = this.originVariant || '';
          });
          this.originVariant = null;
        }
        restorePurchase(this);
        if (card.dataset.customPrice === 'true') paintBindingPrice(this, card);
      }

      shouldRedirect() {
        const card = this.selected;
        const pageId = this.form?.dataset.productId;
        return Boolean(card && pageId && card.dataset.productId !== pageId && card.dataset.variantId);
      }

      onPay(event) {
        if (!this.shouldRedirect()) return;
        const target = event.target instanceof Element ? event.target : null;
        const pay = target?.closest('.shopify-payment-button, shopify-accelerated-checkout, shopify-paypal-button');
        if (!pay || !this.form?.contains(pay)) return;
        event.preventDefault();
        event.stopPropagation();
        if (this.selected?.dataset.available !== 'true') return;
        checkoutBinding(this);
      }
    }

    class ProductBindingCard extends HTMLElement {
      connectedCallback() {
        const list = this.closest('.product-binding-list');
        if (!(list instanceof HTMLElement)) return;
        let group = groups.get(list);
        if (!group) {
          group = new ProductBindingGroup(list);
          groups.set(list, group);
        }
        group.add(this);
      }

      disconnectedCallback() {
        this.bindingGroup?.remove(this);
      }
    }

    customElements.define('product-binding-card', ProductBindingCard);
  })();
  } catch(e) { console.error(e); }
})();

})();
